import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import emptyListIcon from '../../../assets/icons/empty-list.svg';
import s from './SearchModal.module.css';
import sg from '../../../styles/index.module.css';
import { Loader } from '../Loader/Loader';

export function SearchModal({
    hideOverlay,
    setIsEditWarehouseMode,
    buttonsData,
    buttonClick,
    titleText,
    isEmptyProjectForAttachmentList,
}) {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');
    const [newButtonData, setNewButtonData] = useState([]);

    const filterProjectData = useCallback(
        (value) => {
            setSearchValue(value);

            setNewButtonData(
                buttonsData.filter((item) => {
                    if (value === '') {
                        return item;
                    }

                    return item.title.toLowerCase().includes(value.toLowerCase());
                })
            );
        },
        [searchValue, newButtonData]
    );

    useEffect(() => {
        setNewButtonData([...buttonsData]);
    }, [buttonsData]);

    return (
        <div className={s.modal}>
            <div
                className={cx(s.top, {
                    [s.topLoader]: !buttonsData.length && !isEmptyProjectForAttachmentList,
                })}
            >
                <div className={s.titleBlock}>
                    <div className={s.titleWrapper}>
                        <h4 className={s.modalTitle}>{titleText}</h4>
                        <div
                            data-id="close-modal-button"
                            onClick={() => {
                                hideOverlay();
                                if (setIsEditWarehouseMode) {
                                    setIsEditWarehouseMode(false);
                                }
                            }}
                            className={s.crossButton}
                        />
                    </div>
                </div>
            </div>
            <div
                className={cx(s.bottom, {
                    [s.bottomLoader]: !buttonsData.length && !isEmptyProjectForAttachmentList,
                })}
            >
                {buttonsData.length !== 0 && (
                    <div className={s.inputWrapper}>
                        {buttonsData.length > 1 && (
                            <input
                                type="search"
                                data-id="search-modal-input"
                                value={searchValue}
                                className={cx(sg.input, s.searchInput)}
                                onChange={(e) => {
                                    filterProjectData(e.target.value);
                                }}
                            />
                        )}
                        {!!searchValue.length && (
                            <div
                                data-id="clear-search-button"
                                onClick={() => {
                                    filterProjectData('');
                                }}
                                className={cx(s.crossButton, s.clearButton)}
                            />
                        )}
                    </div>
                )}
                {buttonsData.length !== 0 && (
                    <div className={s.warehouseButtonsList}>
                        {newButtonData.map((item) => (
                            <div
                                className={cx(s.additionalModalButton, sg.textEllipsis)}
                                key={item.id}
                                data-id="additional-modal-button"
                                onClick={() => {
                                    buttonClick(item);
                                }}
                            >
                                {item.title}
                            </div>
                        ))}
                    </div>
                )}
                {isEmptyProjectForAttachmentList && (
                    <div className={s.emptyProjectListText}>
                        {t('SearchModal.emptyProjectList.text')}
                    </div>
                )}
                {buttonsData.length !== 0 && !newButtonData.length && (
                    <div className={s.emptyListWrapper}>
                        <img src={emptyListIcon} alt="empty-list-icon" />
                        <p>{t('SearchModal.return.notFound.error')}</p>
                    </div>
                )}
                {!buttonsData.length && !isEmptyProjectForAttachmentList && (
                    <Loader size="mediumDot" color="grayDot" loaderWidth="loaderWidth40" />
                )}
            </div>
        </div>
    );
}
